module.exports = __webpack_public_path__ + "static/media/achivement.d499e0b1.png";